// ✦ Explain — one-click "what is this number?" on any report component.
// Opens the in-page PharOS panel pre-seeded with an explain question that
// carries the component's DB id ("[component: <uuid>]"), so resolution is
// deterministic even for unnamed components.
//
// Uses the same direct-drive mechanic as the Beacon rows: get the panel's
// controller instance from the Stimulus registry and call open() — no
// event-listener dependency. preventDefault/stopPropagation matter because
// some blocks are wrapped in a link_to (clicking must not navigate).
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  async ask(event) {
    event.preventDefault()
    event.stopPropagation()

    const question = this.element.dataset.explainQuestion
    if (!question) return

    const panelEl = document.querySelector('[data-controller~="pharos-page-panel"]')
    if (!panelEl) return

    const panel = window.Stimulus?.getControllerForElementAndIdentifier(panelEl, "pharos-page-panel")
    if (!panel) return

    // Clicking Explain IS the question — the panel handles the whole flow:
    // opens showing only a loader, POSTs in the background, answer streams in.
    panel.askDirect(question)
  }
}
